
import { DataStore } from "/Users/codybontecou/projects/obsidian-plugin-hub/obsidian-timemd/src/store.ts";
import { renderEmbed, parseBlockParams } from "/Users/codybontecou/projects/obsidian-plugin-hub/obsidian-timemd/src/embed.ts";
import { TIME_MD_COLOR_SCHEMES } from "/Users/codybontecou/projects/obsidian-plugin-hub/obsidian-timemd/src/themePresets.ts";

interface TimeMdWindow {
  source: string;
  sourceRepo: string;
  generatedBy: string;
  renderEmbed: typeof renderEmbed;
  parseBlockParams: typeof parseBlockParams;
  colorSchemes: typeof TIME_MD_COLOR_SCHEMES;
  createStore: (report: unknown) => DataStore;
}

declare global {
  interface Window { TimeMdPluginVisualizations: TimeMdWindow; activeDocument: Document; activeWindow: Window; }
}

function createStore(report: unknown): DataStore {
  const fakeApp = { vault: {} } as never;
  const store = new DataStore(fakeApp, () => "");
  (store as any).reports = Array.isArray(report) ? report : [report];
  (store as any).lastLoadedAt = new Date("2026-06-28T12:00:00Z");
  (store as any).lastError = null;
  (store as any).skippedFiles = [];
  return store;
}

window.activeDocument = window.document;
window.activeWindow = window;
window.TimeMdPluginVisualizations = {
  source: "obsidian-timemd src/embed",
  sourceRepo: "/Users/codybontecou/projects/obsidian-plugin-hub/obsidian-timemd",
  generatedBy: "scripts/build-plugin-visualizations.mjs",
  renderEmbed,
  parseBlockParams,
  colorSchemes: TIME_MD_COLOR_SCHEMES,
  createStore,
};
